import type { IconProps } from "@/types/IconProps";

export function Tiktok(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m.316 14.394a1.823 1.823 0 0 1-1.822 1.758c-1 0-1.83-.816-1.83-1.83a1.827 1.827 0 0 1 2.372-1.745v-2.225c-2.428-.323-4.554 1.563-4.555 3.97 0 2.344 1.943 4.013 4.005 4.013a4.01 4.01 0 0 0 4.005-4.013V9.896a5.18 5.18 0 0 0 3.028.971V8.692s-1.324.063-2.282-1.042a3 3 0 0 1-.746-1.985h-2.175z"></path>
    </svg>
  );
}
